export default function Hero() {
  return (
    <section className="hero" id="claim" data-testid="hero-section">
      <div className="hero-inner">
        <div className="hero-content">
          <div className="hero-badge" data-testid="hero-badge">
            An estimated <span className="amount">&pound;7.5 Billion</span> redress to consumers*
          </div>
          <h1>
            You could be owed <span className="hl">&pound;2,075*</span> for your mis-sold car finance agreements.
          </h1>
          <a href="https://sa.yoursolicitor.co.uk/claim" className="btn-primary" data-testid="hero-cta-btn" data-ratifi-forward>
            Check My Claim <span className="arrow">&rarr;</span>
          </a>
          <p className="hero-disclaimer">
            You do not need to use a claims management company or a law firm to make your complaint. You can do this directly. If your complaint is not successful you can refer it to the Financial Ombudsman Service yourself for free.
          </p>
          <p className="hero-time">
            &#9200; It takes a few minutes to <a href="/claim">start your claim</a>
          </p>
        </div>
        <div className="hero-car" data-testid="hero-car">
          <img
            src="/car_hero.png"
            alt="White car with MI55 OLD number plate - mis-sold car finance"
          />
          <p className="hero-car-caption" data-testid="hero-caption">
            &pound;830 is the amount the FCA has estimated consumers could get under their Consumer Redress Scheme. Using our specialist AI-powered solution, we identify an average of 2.5 agreements per client. This means our clients could achieve an average settlement of &pound;2,075. These aren&rsquo;t guaranteed amounts and all claims are subject to eligibility.
          </p>
        </div>
      </div>
    </section>
  );
}
